import { useCallback, useMemo, useState } from 'react';

import { Voucher, VoucherToggle } from '~/services/PromoService';

export function useVoucherToggleFilter(vouchers: Array<Voucher>) {
  const [selectedVoucherToggle, setSelectedVoucherToggle] = useState<VoucherToggle | undefined>();

  const filteredVouchers = useMemo(() => {
    if (!selectedVoucherToggle) {
      return vouchers;
    }
    return vouchers.filter((voucher) => voucher.voucherToggles.includes(selectedVoucherToggle));
  }, [selectedVoucherToggle, vouchers]);

  const selectVoucherToggle = useCallback((toggle: VoucherToggle) => {
    setSelectedVoucherToggle((current) => (current === toggle ? undefined : toggle));
  }, []);

  const clearVoucherToggle = useCallback(() => setSelectedVoucherToggle(undefined), []);

  return { clearVoucherToggle, filteredVouchers, selectedVoucherToggle, selectVoucherToggle };
}
